import { createAxiosInstance } from './http';

export const getBlogPosts = async (params = {}) => {
  const res = await createAxiosInstance().get('/blog', { params });
  const data = res.data.data || res.data;
  return {
    data: (Array.isArray(data) ? data : []).map((post) => ({
      ...post,
      id: post.id || post._id,
      _id: post._id || post.id,
    })),
    pagination: res.data.pagination || {},
  };
};

export const getBlogPostBySlug = async (slug) => {
  const res = await createAxiosInstance().get(`/blog/${encodeURIComponent(slug)}`);
  const post = res.data.data || res.data;
  return post
    ? {
        ...post,
        id: post.id || post._id,
        _id: post._id || post.id,
      }
    : post;
};

